import { render, staticRenderFns } from "./address.vue?vue&type=template&id=116cac3c&"
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('116cac3c')) {
      api.createRecord('116cac3c', component.options)
    } else {
      api.reload('116cac3c', component.options)
    }
    module.hot.accept("./address.vue?vue&type=template&id=116cac3c&", function () {
      api.rerender('116cac3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/msg/address.vue"
export default component.exports